import apiService from '../apiService';

const CONTACT_URL = 'contacts'
const contactService = {

    async createContact(payload) {
        try {
            const response = await apiService.post(`/${CONTACT_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllContacts(params = {}) {
        try {
            const queryParams = new URLSearchParams(params).toString();
            const response = await apiService.get(`/${CONTACT_URL}${queryParams ? `?${queryParams}` : ''}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getSingleContact(id) {
        try {
            const response = await apiService.get(`/${CONTACT_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateContact(payload, id) {
        try {
            const response = await apiService.put(`/${CONTACT_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    // One partial update for many contacts (OL-138): { ids, ...changes }.
    async bulkUpdateContacts(payload) {
        try {
            const response = await apiService.patch(`/${CONTACT_URL}/bulk`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    // The client's ID / driver's licence photo (OL-135). One image per contact.
    async uploadIdPhoto(id, file) {
        const formData = new FormData();
        formData.append('id_photo', file);
        try {
            const response = await apiService.post(`/${CONTACT_URL}/${id}/id-photo`, formData);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteIdPhoto(id) {
        try {
            const response = await apiService.delete(`/${CONTACT_URL}/${id}/id-photo`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteContact(id) {
        try {
            const response = await apiService.delete(`/${CONTACT_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteContacts(payload) {
        try {
            const response = await apiService.post(`/${CONTACT_URL}/bulk-delete`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async importContact(payload) {
        try {
            const response = await apiService.post(`/${CONTACT_URL}/import`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async contactSampleFile() {
        try {
            const response = await apiService.get(`/${CONTACT_URL}/sample`, {
                responseType: "blob"
            });
            return response;
        } catch (error) {
            console.log(error)
            throw error.response.data;
        }
    },

    async sendEmailToContact(payload, id) {
        try {
            const response = await apiService.get(`/${CONTACT_URL}/sendEmail/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    async sendSecureMessage(payload) {
        try {
            const response = await apiService.post(`/securemessage`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    // async getDocumentsForSignature(id) {
    //     try {
    //         const response = await apiService.get(`/documents/sign/${id}`);
    //         return response.data;
    //     } catch (error) {
    //         throw error.response.data;
    //     }
    // },

    // async uploadSignedDocument(token, payload) {
    //     try {
    //         const response = await apiService.post(`/documents/sign/${token}`, payload);
    //         return response.data;
    //     } catch (error) {
    //         throw error.response.data;
    //     }
    // },
};

export default contactService;
